import { useNavigate, useParams } from "react-router-dom";
import { OrderFailure } from "@/components/pages";
import { useCallback } from "react";


const OrderFailureView = () => {
    const { order } = useParams<'order'>();
    const navigate = useNavigate();

    const handleReturnToOrder = useCallback(() => {
        navigate(`/order-view/order=${order}`);
    }, [order, navigate]);

    return (
        <OrderFailure onReturnToOrder={handleReturnToOrder}></OrderFailure>
    );
}

export default OrderFailureView;